<template>
<v-app v-cloak>
  <v-main v-if="initialized">
    <router-view></router-view>
  </v-main>
</v-app>
</template>

<style lang="sass">
  $color-pack: false
  @import '~vuetify/src/styles/main.sass'
</style>

<script>
export default {
  name: "App",

  data() {
    return {
      initialized: false
    }
  },

  created() {
    const inst = this;
    window.iFrameResizer = {
      onMessage(message) {
        if (!("opcode" in message)) {
          return;
        }

        if (message.opcode == "init") {
            if ("nonce" in message) {
              inst.$store.commit("auth/authenticationToken", message.nonce);
            }

            if ("immoWidgetsConfig" in window) {
              // wird von immosuite-frodo hier reingesetzt
              if ("privacyUrl" in window.immoWidgetsConfig && !("privacyUrl" in message)) {
                message.privacyUrl = window.immoWidgetsConfig.privacyUrl;
              }
            }

            inst.$store.commit("appConfig", message);

            inst.initialized = true;
        }
      }
    };
  }
};
</script>
